<template>
  <section>
    <h1>{{ $t('SUPERFLOWS') }}</h1>
  </section>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../scss/variables';
</style>

<script>
// @flow
export default {
  name: 'superflows'
}
</script>
